import { Component } from '@angular/core';

@Component({
  selector: 'am-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  isContentNoMaxWidth: boolean;
  constructor() {}
}
